import jQuery from "jquery";

jQuery(function ($) {
    /*$.urlParam = function(name){
        let url = $(location).attr("href");
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(url);
        return results?results[1] : 0;
    }

    if ($.urlParam('velo')) {
        // Get the product and show it
        $.post(
            "/wp-admin/admin-ajax.php",
            {
                'action': 'get_product',
                'product': $.urlParam('velo')
            },
            function(response){
                (1 === $('.gform_required_legend').length)
                    ? $('.gform_required_legend').before(response)
                    : $('.the-content form').before(response)
                ;
            }
        )
    }*/

    if (0 === $('.product-summary').length) {
        return;
    }

    (1 === $('.gform_required_legend').length)
        ? $('.gform_required_legend').before($('.product-summary').detach())
        : $('.the-content form').before($('.product-summary').detach())
    ;

    $('.product-summary').removeClass('is-hidden');
});
